var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.stockImage
    ? _c("studip-dialog", {
        attrs: {
          height: "720",
          width: "960",
          title: _vm.$gettext("Bild bearbeiten"),
          closeClass: "cancel",
          closeText: _vm.$gettext("Schließen"),
        },
        on: {
          close: _vm.onCancel,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "dialogContent",
              fn: function fn() {
                return [
                  _c(
                    "form",
                    {
                      staticClass: "default",
                      attrs: {
                        id: "stock-images-edit-form",
                      },
                      on: {
                        submit: function submit($event) {
                          $event.preventDefault()
                          return _vm.onSubmit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("ThumbnailCard", {
                            attrs: {
                              chdate: new Date(
                                _vm.stockImage.attributes.chdate
                              ),
                              height: _vm.stockImage.attributes.height,
                              "mime-type":
                                _vm.stockImage.attributes["mime-type"],
                              mkdate: new Date(
                                _vm.stockImage.attributes.mkdate
                              ),
                              size: _vm.stockImage.attributes.size,
                              url: _vm.stockImage.attributes["download-urls"]
                                .small,
                              width: _vm.stockImage.attributes.width,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("AttributesFieldset", {
                            attrs: {
                              metadata: _vm.metadata,
                              "suggested-tags": _vm.suggestedTags,
                            },
                            on: {
                              change: _vm.onChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "dialogButtons",
              fn: function fn() {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "button accept",
                      attrs: {
                        form: "stock-images-edit-form",
                        type: "submit",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$gettext("Speichern")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          633415466
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }